import React from 'react';
import { useThemeName } from '@adc/parallax-component-library';
import i18n from 'Utilities/i18n';
function ThemedImage({ resourceKey, id, alt, style }) {
    const theme = useThemeName();
    const mainKey = resourceKey.endsWith('Light')
        ? resourceKey.slice(0, resourceKey.length - 5)
        : resourceKey.slice(0, resourceKey.length - 4);
    const rKey = `${mainKey}${theme === 'light' ? 'Light' : 'Dark'}`;
    const resource = i18n.t(rKey);
    return React.createElement("img", { src: resource, alt: alt, id: id ?? rKey, style: style });
}
export { ThemedImage };
